<div
  [matTooltip]="isOverflowing ? text : ''"
  [matTooltipDisabled]="!isOverflowing"
  [matTooltipPositionAtOrigin]="true"
  matTooltipClass="text-overflow-tooltip"
  #textContainer
  (mouseenter)="checkOverflow()"
  (mouseleave)="tooltip.hide()"
>
  {{ text }}
</div>
